import { InfoIcon } from "@phosphor-icons/react/dist/csr/Info";
import { Button } from "@volca/ui/components/ui/button";
import { Stack } from "@volca/ui/components/ui/stack";
import { Text } from "@volca/ui/components/ui/text";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from "@volca/ui/components/ui/tooltip";
import { cn } from "@volca/ui/lib/utils";

interface DetailFieldProps {
  label: string;
  message?: string | null;
  subMessage?: string | null;
  onClick?: () => void;
  extraInfo?: React.ReactNode | null;
  fullWidth?: boolean;
  className?: string;
}

export const DetailField = ({
  label,
  message,
  subMessage,
  fullWidth = true,
  className,
  extraInfo,
  onClick,
}: DetailFieldProps) => (
  <Stack
    align="start"
    gap={2}
    className={cn(className, { "w-full": fullWidth })}
  >
    <Stack direction="row" align="center" gap={1}>
      <Text variant="label" tone="muted">
        {label}
      </Text>
      {extraInfo && (
        <Tooltip>
          <TooltipTrigger
            render={<InfoIcon className="h-4 w-4 text-subtle" />}
          />
          <TooltipContent className="block max-w-lg">
            {extraInfo}
          </TooltipContent>
        </Tooltip>
      )}
    </Stack>
    {onClick ? (
      <Button variant="link" onClick={onClick} className="h-auto p-0">
        {message}
      </Button>
    ) : (
      <Text>{message}</Text>
    )}
    {subMessage && (
      <Text variant="caption" tone="muted">
        {subMessage}
      </Text>
    )}
  </Stack>
);
